export const Currency = [
  'MYR',
  'RMB',
  'EURO',
  'USD'
]
